enum CardHeight {
  LARGE_WITH_TABS = 132,
  LARGE = 108,
  TABS = 210,
  DEFAULT = 190,
}

export const getCardHeight = (upLg: boolean, hasTabs: boolean): number => {
  if (upLg && hasTabs) {
    return CardHeight.LARGE_WITH_TABS
  }
  if (upLg) {
    return CardHeight.LARGE
  }
  if (hasTabs) {
    return CardHeight.TABS
  }
  return 190
}
